import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Home from '../home/Home'
import Servicios from '../servicios/Servicios'
import Clinica from '../clinica/Clinica'
import Localizacion from '../localizacion/Localizacion'
import Contacto from '../contacto/Contacto'
import NotFound from '../notfound/NotFound'
import './Main.css'

const Main = () => (
    <main id="Main" className="Main">
        <Switch>
            <Route path='/' exact component={Home} />
            <Route path='/servicios' component={Servicios} />
            <Route path='/clinica' component={Clinica} />
            <Route path='/localizacion' component={Localizacion} />
            <Route path='/contacto' component={Contacto} />
            <Route component={NotFound} />
        </Switch>
    </main>
)

export default Main


// WEBPACK FOOTER //
// ./src/components/main/Main.js